import axios from 'axios'

const DashboardService = {
  async getTotalCustomers (params = {}) {
    return axios.get('fso/dashboard', { params })
  }
}

export default DashboardService
